module.exports = __webpack_public_path__ + "img/LV40003563375.19e3d194.png";